import React from 'react';
import defaultProfile from '../../assets/default-user.png';
import defaultBackground from '../../assets/header-background.jpg';

const Header = ({organizer, baseURL}) => {
  return (
    <section className="company-first">
      <div className="position-relative w-100"><img className="detail-banner" src={organizer.backgroundPicture ? baseURL+'/'+organizer.backgroundPicture : defaultBackground} alt="detail-privvy" />
        <div className="kunjungi d-lg-block d-md-block d-sm-none d-none">
          <div className="d-flex">
            <a className="btn btn-white" href={organizer.website} style={{background: 'white'}} target="_blank">Kunjungi Website
            </a>
          </div>
        </div>
        <div className="foto-profil">
          <div className="d-flex" style={{flexWrap: 'wrap'}}>
            <div className="foto mr-4"><img src={organizer.profilePicture ? baseURL+'/'+organizer.profilePicture : defaultProfile} alt="logo-privy-colored" style={{width: '100%',height: 'auto'}} /></div>
            <div className="d-lg-block d-md-block d-sm-none d-none" style={{marginTop: '90px'}}>
              <p style={{fontSize: '20px', fontWeight: '600'}}>{organizer.companyName}</p>
              <div className="d-flex">
                <p className="text-muted mr-5" style={{fontSize: '12px'}}>{organizer.type}</p>
                <p className="text-muted mr-5" style={{fontSize: '12px'}}>{organizer.noRef}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-lg-none d-md-none d-sm-block d-block" style={{marginTop: '90px'}}>
        <div className="container" style={{padding: '30px'}}>
          <p style={{fontSize: '20px', fontWeight: '600'}}>{organizer.companyName}</p>
          <p className="text-muted mr-5" style={{fontSize: '12px'}}>{organizer.type}</p>
          <p className="text-muted mr-5" style={{fontSize: '12px'}}>{organizer.noRef}</p>
        </div>
      </div>
    </section>
  )
}

export default Header